import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiLogOut, FiCalendar, FiUser, FiHome, FiFileText, FiHelpCircle, FiMessageSquare } from 'react-icons/fi';
import { PiDog } from "react-icons/pi";
import { AiOutlineTeam, AiOutlineCheck } from "react-icons/ai";
import { MdOutlineTask, MdSchool } from "react-icons/md";
import { BsClipboardCheck } from "react-icons/bs";
import { TrainerContext } from "../../context/TrainerContext";
import LanguageSwitcher from '../commons/LanguageSwitcher';
import '../../styles/MobileSidebar.css';

const MobileTrainerSidebar = () => {
    const { t } = useTranslation('common');
    const navigate = useNavigate();
    const { trainer } = useContext(TrainerContext);

    // Display trainer's name
    const displayName = trainer?.firstName && trainer?.lastName
        ? `${trainer.firstName} ${trainer.lastName}`
        : trainer?.username || 'Trainer';

    const handleLogout = () => {
        localStorage.removeItem('jwt');
        localStorage.removeItem('refreshToken');

        const mobileSidebar = document.querySelector('.mobile-sidebar');
        const backdrop = document.querySelector('.sidebar-backdrop');

        if (mobileSidebar) {
            mobileSidebar.classList.remove('open');
        }

        if (backdrop) {
            backdrop.remove();
        }

        navigate('/');
    };

    const navigateTo = (path) => {
        navigate(path);
        const mobileSidebar = document.querySelector('.mobile-sidebar');
        const backdrop = document.querySelector('.sidebar-backdrop');

        if (mobileSidebar) {
            mobileSidebar.classList.remove('open');
        }

        if (backdrop) {
            backdrop.remove();
        }
    };

    return (
        <div className="mobile-sidebar">
            <div className="profile-section">
                <div className="profile-icon">
                    <span>{displayName.charAt(0)}</span>
                </div>
                <p>{displayName}</p>
            </div>

            <nav className="nav-section">
                <ul>
                    <li>
                        <button className="nav-button" onClick={() => navigateTo('/dashboard')}>
                            <FiHome /> {t('sidebar.dashboard')}
                        </button>
                    </li>
                    <li>
                        <button className="nav-button" onClick={() => navigateTo('/podopieczni')} data-onboarding="pets">
                            <PiDog /> {t('sidebar.pets')}
                        </button>
                    </li>
                    <li>
                        <button className="nav-button" onClick={() => navigateTo('/owners/all')} data-onboarding="owners">
                            <AiOutlineTeam /> {t('sidebar.owners')}
                        </button>
                    </li>
                    <li>
                        <button className="nav-button" onClick={() => navigateTo('/exercises')} data-onboarding="exercises">
                            <MdOutlineTask /> {t('sidebar.exercises')}
                        </button>
                    </li>
                    <li>
                        <button className="nav-button" onClick={() => navigateTo('/reports')} data-onboarding="reports">
                            <FiFileText /> {t('sidebar.reports')}
                        </button>
                    </li>
                    <li>
                        <button className="nav-button" onClick={() => navigateTo(`/survey/school/${trainer?.schoolId}/all`)} data-onboarding="surveys">
                            <BsClipboardCheck /> {t('sidebar.surveys')}
                        </button>
                    </li>
                    <li>
                        <button className="nav-button" onClick={() => navigateTo('/calendar')} data-onboarding="calendar">
                            <FiCalendar /> {t('sidebar.calendar')}
                        </button>
                    </li>
                    <li>
                        <button className="nav-button" onClick={() => navigateTo('/trainings/confirmed')} data-onboarding="trainings">
                            <AiOutlineCheck /> {t('sidebar.trainings')}
                        </button>
                    </li>
                    <li>
                        <button className="nav-button" onClick={() => navigateTo('/trainer/groups')} data-onboarding="groups">
                            <AiOutlineTeam /> {t('sidebar.groups')}
                        </button>
                    </li>
                    <li>
                        <button className="nav-button" onClick={() => navigateTo('/chat')}>
                            <FiMessageSquare /> {t('sidebar.chat')}
                        </button>
                    </li>
                    <li>
                        <button className="nav-button" onClick={() => navigateTo('/school/details')} data-onboarding="school">
                            <MdSchool /> {t('sidebar.school')}
                        </button>
                    </li>
                    <li>
                        <button className="nav-button" onClick={() => navigateTo('/trainer/account')} data-onboarding="my-account">
                            <FiUser /> {t('sidebar.account')}
                        </button>
                    </li>
                    <li>
                        <button className="nav-button" onClick={() => navigateTo('/trainer/help')}>
                            <FiHelpCircle /> {t('sidebar.help')}
                        </button>
                    </li>
                </ul>
            </nav>

            <LanguageSwitcher variant="sidebar" />
            <button className="logout-button" onClick={handleLogout}>
                <FiLogOut className="logout-icon" /> {t('sidebar.logout')}
            </button>
        </div>
    );
};

export default MobileTrainerSidebar;
